import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-brand-guarantee border-y-4 border-brand-green" data-id="element-164">
      <div className="max-w-4xl mx-auto text-center" data-id="element-165">
        <ShieldCheckIcon className="w-24 h-24 text-brand-green mx-auto mb-6" data-id="element-166" />

        <h2 className="text-4xl md:text-5xl font-black text-brand-dark mb-8 uppercase" data-id="element-167">
          🛡️ GARANTÍA QUÍMICA EN ACCIÓN — 7 DÍAS
        </h2>

        <div className="text-xl md:text-2xl text-gray-800 space-y-4 font-medium mb-12 max-w-3xl mx-auto" data-id="element-168">
          <p data-id="element-169">
            Abrís los 5 cuadernillos. Revisás los 6 bonos. Los usás en el aula
            si querés.
          </p>
          <p className="font-bold text-brand-dark" data-id="element-170">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-3xl font-black text-brand-green py-4" data-id="element-171">
            Te devolvemos el 100%.
          </p>
          <p data-id="element-172">Sin preguntas. Sin formularios. Sin vueltas.</p>
          <p className="text-lg text-gray-600 mt-6" data-id="element-173">
            La confianza que tenemos en QUÍMICA EN ACCIÓN nos permite ofrecerte
            esto.
            <br data-id="element-174" />
            Cientos de docentes de Química ya lo saben.
          </p>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-175">
          <CTAButton text="→ EMPEZAR HOY CON GARANTÍA" href="#compra" data-id="element-176" />
        </div>
      </div>
    </section>;
}